
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"31","height":"31","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.188 4.844a2.906 2.906 0 115.812 0v21.312a2.906 2.906 0 11-5.813 0V4.844zM23.25 6.246c-4.005 1.841-8.794 2.87-13.563 3.209v12.084c.704.04 1.407.095 2.109.165 3.977.395 7.823 1.294 11.454 3.023V6.247zM7.75 21.439V9.56c-1.317.052-2.71.083-3.89.102a3.914 3.914 0 00-3.86 3.9v3.876c0 2.142 1.736 3.867 3.863 3.892a128.274 128.274 0 013.887.108zm2.693 2.095c.552.04 1.103.09 1.647.151l.49 3.274a1.94 1.94 0 01-1.904 2.3H9.614a1.937 1.937 0 01-1.775-1.16l-2.546-4.805c1.093.027 2.186.068 3.279.124.633.033 1.259.071 1.871.116z","fill":"#3B3B3B"}})])
          )
        }
      }
    